<template>
	<div class="BuyerAccountApplicationRecord">
		<div class="summary_bag">
			<div class="summary_complete_bag">
				<!-- 时间 -->
				<el-form
					:inline="true"
					label-width="120px"
					ref="selectForm"
					:model="selectForm"
				>
					<el-form-item
						label="选择分部门"
						prop="departmentValue"
						v-if="
							UserInfo.system < 3 ||
								UserInfo.superDepartmentName === '客服部' ||
								(UserInfo.system === 5 &&
									UserInfo.superDepartmentName ===
										'常规客服部')
						"
					>
						<el-select
							clearable
							v-model="selectForm.departmentValue"
							placeholder="请选择"
							value-key="rid"
							@change="selectChange($event, 'groupList')"
						>
							<el-option
								v-for="item in departmentList"
								:key="item.rid"
								:label="item.departmentName"
								:value="item"
							></el-option>
						</el-select>
					</el-form-item>
					<el-form-item
						label="选择组"
						prop="groupValue"
						v-if="
							UserInfo.system < 4 ||
								UserInfo.superDepartmentName === '客服部' ||
								(UserInfo.system === 5 &&
									UserInfo.superDepartmentName ===
										'常规客服部')
						"
					>
						<el-select
							clearable
							v-model="selectForm.groupValue"
							placeholder="请选择"
							value-key="rid"
							@change="selectChange($event, 'staffList')"
						>
							<el-option
								v-for="item in groupList"
								:key="item.rid"
								:label="item.groupName"
								:value="item"
							></el-option>
						</el-select>
					</el-form-item>
					<el-form-item
						label="选择员工"
						prop="staffValue"
						v-if="
							UserInfo.system < 5 ||
								UserInfo.superDepartmentName === '客服部' ||
								(UserInfo.system === 5 &&
									UserInfo.superDepartmentName ===
										'常规客服部')
						"
					>
						<el-select
							clearable
							v-model="selectForm.staffValue"
							placeholder="请选择"
							value-key="rid"
							@change="selectChange($event)"
						>
							<el-option
								v-for="item in staffList"
								:key="item.rid"
								:label="item.roleUserName"
								:value="item"
							></el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="买家账号组合方案" prop="value">
						<el-select
							clearable
							v-model="selectForm.value"
							placeholder="请选择"
							@change="handleValue"
						>
							<el-option
								v-for="(item, index) in List"
								:key="index"
								:label="item.programName"
								:value="item.id"
							></el-option>
						</el-select>
					</el-form-item>
					<!-- <el-form-item label="审核人" prop="mark">
						<el-select v-model="selectForm.mark">
							<el-option
								v-for="(item, index) in List1"
								:key="index"
								:label="item.roleName + '-' + item.userName"
								:value="item.rid"
							></el-option>
						</el-select>
					</el-form-item> -->
					<el-form-item label="审批状态" prop="isTranslation">
						<el-select clearable v-model="selectForm.isTranslation">
							<!-- <el-option label="全部" :value="1"></el-option> -->
							<el-option label="未审批" :value="0"></el-option>
							<el-option label="已审批" :value="1"></el-option>
						</el-select>
					</el-form-item><br>
                    <el-form-item>
                        <span slot="label">
                            <span class="span-box">
                                <p>国家</p>
                                <el-tooltip style="diaplay:inline" effect="dark" content="此国家为下单账号所属国家，及该国家账号还有多少" placement="top">
                                    <i class="el-icon-question" />
                                </el-tooltip>
                            </span>
                        </span>
						<el-radio-group v-model="selectForm.country">
							<el-row type="flex">
								<el-radio label="US">美国 ( {{ countryList.US }} )</el-radio>
								<el-radio label="CA">加拿大 ( {{ countryList.CA }} )</el-radio>
								<el-radio label="MX">墨西哥 ( {{ countryList.MX }} )</el-radio>
							</el-row>
							<el-row type="flex" style="margin: 10px 0">
								<el-radio label="GB">英国 ( {{ countryList.GB }} )</el-radio>
								<el-radio label="DE">德国 ( {{ countryList.DE }} )</el-radio>
								<el-radio label="FR">法国 ( {{ countryList.FR }} )</el-radio>
								<el-radio label="IT">意大利 ( {{ countryList.IT }} )</el-radio>
								<el-radio label="ES">西班牙 ( {{ countryList.ES }} )</el-radio>
								<el-radio label="NL">荷兰 ( {{ countryList.NL }} )</el-radio>
								<el-radio label="SE">瑞典 ( {{ countryList.SE }} )</el-radio>
								<el-radio label="PL">波兰 ( {{ countryList.PL }} )</el-radio>
								<el-radio label="SA">沙特阿拉伯 ( {{ countryList.SA }} )</el-radio>
								<el-radio label="AE">阿联酋 ( {{ countryList.AE }} )</el-radio>
							</el-row>
							<el-row type="flex">
								<el-radio label="JP">日本 ( {{ countryList.JP }} )</el-radio>
								<el-radio label="AU">澳大利亚 ( {{ countryList.AU }} )</el-radio>
								<el-radio label="SG">新加坡 ( {{ countryList.SG }} )</el-radio>
							</el-row>
							<!-- <el-radio v-for="(item,index) in country" :key="index" :label="item.value">{{item.name}}</el-radio> -->
						</el-radio-group>
                    </el-form-item><br>
					<el-form-item label="时间筛选类型" prop="isTranslation">
						<el-radio-group v-model="selectForm.timeType">
                            <el-radio :label="1">申请时间</el-radio>
                            <el-radio :label="2">审核时间</el-radio>
						</el-radio-group>
					</el-form-item>
					<el-form-item label="开始日期" prop="startTime">
						<el-date-picker
							v-model="selectForm.startTime"
							align="right"
							type="datetime"
							:picker-options="pickerOptions"
							placeholder="选择开始日期"
							value-format="yyyy-MM-dd HH:mm:ss"
							style="width:200px;"
						></el-date-picker>
					</el-form-item>
					<el-form-item label="结束日期" prop="endTime">
						<el-date-picker
							v-model="selectForm.endTime"
							align="right"
							type="datetime"
							:picker-options="pickerOptions"
							placeholder="选择结束日期"
							value-format="yyyy-MM-dd HH:mm:ss"
							style="width:200px;"
						></el-date-picker>
					</el-form-item>
					<el-form-item label=" " prop="input">
						<el-input
							class="custom-input"
							v-model="selectForm.input"
							placeholder="全字段搜索"
							style="width:361px;"
							clearable
						></el-input>
					</el-form-item>
					<el-form-item>
						<el-button type="primary"
							@click="Search"
							>搜索</el-button
						>
						<el-button
							type="primary"
							 @click="searchReset"
							>重置</el-button
						>
					</el-form-item>
				</el-form>
			</div>
			<!-- 买家账号审批流程设置-->
			<div class="summary_pagenum" v-if="UserInfo.system === 5">
                <el-button type="text" @click="edit">买家账号申请</el-button>
			</div>
			<div class="summary_content">
				<div class="summary_list">
					<!-- 头部 -->
					<el-table
						:data="summarylist"
						style="width: 100%"
						v-loading="load_data"
						element-loading-text="拼命加载中"
						border
						:header-cell-style="iscenter"
						stripe
					>
						<el-table-column
							label="单据编号"
							prop="id"
							width="80"
							align="center"
						></el-table-column>
						<el-table-column
							label="买家账号方案"
							align="center"
							prop="buyerAccountCombinationPlan"
						>
						</el-table-column>
						<el-table-column
							prop="applicationCount"
							width="80px"
							label="数量"
							align="center">
						</el-table-column>
						<el-table-column
							prop="country"
							label="国家"
							align="center"
						></el-table-column>
						<el-table-column
							prop="createTime"
							label="申请时间"
							align="center"
						></el-table-column>
						<el-table-column
							label="审核人"
							align="center"
						>
						<template slot-scope="scope">
							<div v-for="(item,index) in scope.row.buyerAccountReviewRecordList" :key="index">
								{{ item.reviewerName }}
							</div>
						</template>
						</el-table-column>
						<el-table-column
							label="审核状态"
							align="center"
						>
						<template slot-scope="scope">
							<div v-for="(item,index) in scope.row.buyerAccountReviewRecordList" :key="index">
								<p v-if="item.reviewStatus === 2" style="color:red">审核失败</p>
								<p v-else-if="item.reviewStatus === 1" style="color:green">审核通过</p>
							</div>
						</template>
						</el-table-column>
						<el-table-column
							label="审核时间"
							align="center"
						>
						<template slot-scope="scope">
							<div v-for="(item,index) in scope.row.buyerAccountReviewRecordList" :key="index">
								{{ item.reviewTime }}
							</div>
						</template>
						</el-table-column>
						<el-table-column
							label="费用总计"
							align="center"
							prop="totalCost"
							width="100px" 
						>
						</el-table-column>
						<el-table-column
							label="申请人"
							align="center"
							prop="applicantName"
							width="260px"
						>
						</el-table-column>
						<el-table-column
							label="操作"
							align="center"
						>
							<template slot-scope="scope">
								<el-button type="primary" @click="editor(scope.row)" v-if="scope.row.approvalStatus === 0">编辑</el-button>
								<el-button type="primary" v-else-if="scope.row.approvalStatus === 1" disabled>编辑</el-button>
								<el-button type="danger" @click="delModify(scope.row)"  v-if="scope.row.approvalStatus === 0">删除</el-button>
								<el-button type="danger" v-else-if="scope.row.approvalStatus === 1" disabled>删除</el-button>
							</template>
						</el-table-column>
					</el-table>
				</div>
			</div>
            <div class="summary_pagenum_block">
                <div class="block">
                    <el-pagination
                        @current-change="handleCurrentChange"
                        :current-page="page"
					    :page-size="size"
                        @size-change="handleSizeChange"
                        :page-sizes="[10, 20, 50, 100]"
                        layout="total, sizes, prev, pager, next, jumper"
                        :total="total"
                    ></el-pagination>
                </div>
            </div>
		</div>  
		<el-dialog
			title="编辑"
			:visible.sync="EditReimbursement1"
			width="38%">
			<div>
				<el-form inline class="form" :model="form1" ref="form1">
					<el-form-item label="买家账号组合方案" :label-width="formLabelWidth">
						<el-select
							clearable
							v-model="form1.buyerAccountCombinationId"
							placeholder="请选择"
							@change="handleClick1($event)"
						>
							<el-option
								v-for="(item, index) in List"
								:key="index"
								:label="item.programName"
								:value="item.id"
							></el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="申请国家" :label-width="formLabelWidth">
							<el-select
								clearable
								v-model="form1.countryCode"
								placeholder="请选择"
							>
								<el-option
									v-for="(item, index) in country"
									:key="index"
									:label="item.name"
									:value="item.Referred"
								></el-option>
							</el-select>
					</el-form-item>
					<el-form-item label="申请数量" :label-width="formLabelWidth">
						<el-input-number v-model="form1.applicationCount" 
							:min="1" size="small" controls-position="right" 
							@change="handleChange1"
						></el-input-number>
					</el-form-item>
					<el-form-item label="总费用" :label-width="formLabelWidth">
						<el-input v-model="form1.totalCost" disabled	></el-input>元
					</el-form-item>
				</el-form>
			</div>
			<div slot="footer">
				<el-button @click="EditReimbursement1 = false">取 消</el-button>
				<el-button type="primary" @click="editModify">确 定</el-button>
			</div>
		</el-dialog>
        <el-dialog title="买家账号申请" :visible.sync="EditReimbursement" width="38%">
            <el-row type="flex" justify="end">
                <el-button type="primary" @click="dialogVisible = true">说明</el-button>
            </el-row>
            <el-form inline class="form" v-for="(item,index) in buyerAccountApplicationList" :key="index">
                <el-form-item label="买家账号组合方案" :label-width="formLabelWidth">
                    <el-select
						clearable
                        v-model="item.buyerAccountCombinationId"
                        placeholder="请选择"
						@change="handleClick(item,$event)"
                    >
                        <el-option
                            v-for="(item, index) in List"
                            :key="index"
                            :label="item.programName + '   ' +'可申请: ' + item.availableCount"
                            :value="item.id"
                        ></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="申请国家" :label-width="formLabelWidth">
						<el-select
							clearable
							v-model="item.countryCode"
							placeholder="请选择"
						>
							<el-option
								v-for="(item, index) in country"
								:key="index"
								:label="item.name"
								:value="item.Referred"
							></el-option>
						</el-select>
                </el-form-item>
                <el-form-item label="申请数量" :label-width="formLabelWidth">
                    <el-input-number v-model="item.applicationCount" 
						:min="1" size="small" controls-position="right" 
						@change="handleChange"
					></el-input-number>
                </el-form-item>
                <el-form-item label="总费用" :label-width="formLabelWidth">
                    <el-input v-model="item.totalCost" disabled	></el-input>元
                </el-form-item>
                <el-button type="primary" @click="addPlan">新增组合方案申请</el-button>
				<el-button v-if="index > 0" @click="handeCanel(index)">取消</el-button>
            </el-form>
            <el-row type="flex" justify="end" style="margin-top:10px">
                <p>合计费用：{{ costTotal }}元</p>
            </el-row>
            <div slot="footer" class="dialog-footer">
                <el-button @click="EditReimbursement = false">取消</el-button>
                <el-button type="primary" @click="EditbankCard">确认申请</el-button>
            </div>
        </el-dialog>
		<el-dialog
			title="买家账号组合方案说明"
			:visible.sync="dialogVisible"
			width="35%">
			<div>
				<el-row type="flex" align="middle" v-for="(item,index) in List" :key="index">
					<h3>方案{{index + 1}}：{{ item.programName }}</h3>
					<el-button type="text" style="border:none" @click="toDialog(item)">详情</el-button>
				</el-row>
			</div>
			<div slot="footer">
				<el-button @click="dialogVisible = false">取 消</el-button>
				<el-button type="primary" @click="dialogVisible = false">确 定</el-button>
			</div>
		</el-dialog>
		<el-dialog
			title="详情"
			:visible.sync="dialogVisible1"
			width="35%">
			<div>
				<div>
					<p style="margin-bottom:5px">买家账号等级名称：{{ details.gradeName }}</p>
					<p>收费标准：{{ details.charge }}</p>
					<p style="margin: 5px 0">用途说明：{{ details.usageDescription }}</p>
					<p>注意事项：{{ details.precautions }}</p>
				</div>
				<div style="margin: 20px 0">
					<p style="margin-bottom:5px">信用卡账号等级名称：{{ details1.gradeName }}</p>
					<p>收费标准：{{ details1.charge }}</p>
					<p style="margin: 5px 0">用途说明：{{ details1.usageDescription }}</p>
					<p>注意事项：{{ details1.precautions }}</p>
				</div>
				<div>
					<p style="margin-bottom:5px">买家地址等级名称：{{ details2.gradeName }}</p>
					<p>收费标准：{{ details2.charge }}</p>
					<p style="margin: 5px 0">用途说明：{{ details2.usageDescription }}</p>
					<p>注意事项：{{ details2.precautions }}</p>
				</div>
				<div style="margin-top	: 20px">
					<p style="margin-bottom:5px">下单IP地址等级名称：{{ details3.gradeName }}</p>
					<p>收费标准：{{ details3.charge }}</p>
					<p style="margin: 5px 0">用途说明：{{ details3.usageDescription }}</p>
					<p>注意事项：{{ details3.precautions }}</p>
				</div>
			</div>
			<div slot="footer">
				<el-button @click="dialogVisible1 = false">取 消</el-button>
				<el-button type="primary" @click="dialogVisible1 = false">确 定</el-button>
			</div>
		</el-dialog>
	</div>
</template>

<script>
import { ajaxPost, Baseurl } from '../../../api/api/api'
export default {
	name: 'BuyerAccountApplicationRecord',
	data() {
		return {
			pickerOptions: {
				disabledDate(time) {
					return time.getTime() > Date.now()
				},
				shortcuts: [
					{
						text: '本月',
						onClick: (picker) => {
							const date = new Date()
							picker.$emit('pick', date)
							this.calculationDate()
						},
					},
					{
						text: '上一月',
						onClick: (picker) => {
							const date = new Date()
							picker.$emit('pick', date)
							this.calculationDate(-1)
						},
					},
					{
						text: '上两月',
						onClick: (picker) => {
							const date = new Date()
							picker.$emit('pick', date)
							this.calculationDate(-2)
						},
					},
					{
						text: '上三月',
						onClick: (picker) => {
							const date = new Date()
							picker.$emit('pick', date)
							this.calculationDate(-3)
						},
					},
				],
			},
			dialogVisible: false,
			dialogVisible1: false,
            buyerAccountApplicationList: [
				// { 
				// 	applicationCount: '1'
				// }
			],
			size: 20,
			total: 0,
			page: 1,
			companyId: '',
			staffId: '',
			form1: {},
            formLabelWidth: "120px",
			iscenter: {
				textAlign: 'center',
				background: '#f8f8f8',
				color: '#232323',
			},
			arr: '',
			arr1: '',
			countryList: {},
            EditReimbursement: false,
			EditReimbursement1: false,
			load_data: false,
			UserInfo: {},
			List: [],
			List1: [],
			details: '',
			details1: '',
			details2: '',
			details3: '',
			costTotal: 0,
            summarylist: [],
			selectForm: {
                timeType: '',
				value: '',
				startTime: '',
				endTime: '',
				input: '',
				country: '',
				departmentValue: {},
				groupValue: {},
				staffValue: {},
				mark: '',
				isTranslation: '',
			},
            departmentList: [],
            groupList: [],
            staffList: [],
            country: [
                { value: 0, name: '美国', Referred: 'US' },
                { value: 1, name: '加拿大', Referred: 'CA' },
                { value: 2, name: '墨西哥', Referred: 'MX' },
                { value: 3, name: '英国', Referred: 'GB' },
                { value: 4, name: '德国', Referred: 'DE' },
                { value: 5, name: '法国', Referred: 'FR' },
                { value: 6, name: '意大利', Referred: 'IT' },
                { value: 7, name: '西班牙', Referred: 'ES' },
                { value: 8, name: '荷兰', Referred: 'NL' },
                { value: 9, name: '瑞典', Referred: 'SE' },
                { value: 10, name: '波兰', Referred: 'PL' },
                { value: 11, name: '沙特阿拉伯', Referred: 'SA' },
                { value: 12, name: '阿联酋', Referred: 'AE' },
                { value: 13, name: '日本', Referred: 'JP' },
                { value: 14, name: '澳大利亚', Referred:'AU' },
                { value: 15, name: '新加坡', Referred: 'SG' }

            ]
		}
	},
	created() {
        this.UserInfo = JSON.parse(localStorage.getItem('role'))
		this.init()
		this.selectSettings()
		this.getAccountApplications()
		this.selectReviewer()
		this.AccountNumber()
		if (
			this.UserInfo.system !== 5 &&
			this.UserInfo.superDepartmentName !== '运营部'
		) {
			this.operateWidth = 80
		}
	},
	methods: {
		handleValue() {
			this.AccountNumber()
		},
		editor(item) {
			this.EditReimbursement1 = true
			this.form1 = item
		},
		toDialog(item) {
			this.dialogVisible1 = true
			this.details = item.buyerAccountSetting
			this.details1 = item.creditCardSetting
			this.details2 = item.buyerAddressSetting
			this.details3 = item.orderIPAddressSetting
		},
		// 查询各国买家账号数量
		AccountNumber() {
			const API = Baseurl + 'companyBuyerInfoController/selectCompanyBuyerInfoCountByRid'
			const paramsData = {
				companyId: this.companyId,
				buyerAccountCombinationId: this.selectForm.value,
				rid: this.staffId
			}
			ajaxPost(API,paramsData)
				.then((res) => {
					if(res.data.code === 200) {
						this.countryList = res.data.data
					}else {
						this.$message.error(res.data.data)
					}
				})
		},
		editModify() {
			const API = Baseurl + 'buyerAccountApplicationController/updateBuyerAccountApplication'
			const paramsData = {
				id: this.form1.id,
				buyerAccountCombinationId: this.form1.buyerAccountCombinationId,
				countryCode: this.form1.countryCode,
				applicationCount: this.form1.applicationCount,
				totalCost: this.form1.totalCost
			}
			ajaxPost(API,paramsData)
				.then((res) => {
					if(res.data.code === 200) {
						this.EditReimbursement1 = false
						this.getAccountApplications()
					}else {
						this.$message.error(res.data.data)
					}
				})
		},
		Search(){
			this.getAccountApplications()
		},
        // 分页查询
        getAccountApplications() {
			this.load_data = true
            const API =  Baseurl + 'buyerAccountApplicationController/selectBuyerAccountApplications'
            const paramsData = {
				rid: this.staffId,       
                timeType: this.selectForm.timeType,
				reviewer: this.selectForm.mark,
				approvalStatus: this.selectForm.isTranslation,
				buyerAccountCombinationId: this.selectForm.value,
                countryCode: this.selectForm.country,
                beginDate: this.selectForm.startTime,
                endDate: this.selectForm.endTime,
                companyId: this.companyId,                     // 公司id
                page: this.page,
                size: this.size
            }
            ajaxPost(API,paramsData)
                .then((res) => {
                    this.load_data = false
                    if( res.data.code === 200 ) {
						this.summarylist = res.data.data.list
						this.total = res.data.data.total
                    }else {
						this.$message.error(res.data.data)
					}
                })
        },
		delModify(item) {
            this.$confirm('确定要删除该项吗', '提示').then(() => {
				const API =  Baseurl + 'buyerAccountApplicationController/deleteBuyerAccountApplication'
				const paramsData = {
					id: item.id
				}
				ajaxPost(API,paramsData)
					.then((res) => {
						this.load_data = false
						if( res.data.code === 200 ) {
							this.getAccountApplications()
							this.AccountNumber()
							this.$message.success('操作成功')
						}else {
							this.$message.error(res.data.data)
						}
					})
			})
		},
		selectSettings() {
			const API =  Baseurl + 'buyerAccountCombinationController/selectBuyerAccountCombinations'
			const paramsData = {      
				companyId: this.companyId                                // 公司id
			}
			ajaxPost(API,paramsData)
				.then((res) => {
					if( res.data.code === 200 ) {
						this.List = res.data.data
					}else {
						this.$message.error(res.data.data)
					}
				})
		},
		selectReviewer() {
			const API =  Baseurl + 'roleController/selectSuperiorByRid'
			const paramsData = {      
				rid: this.staffId                                           // 公司id
			}
			ajaxPost(API,paramsData)
				.then((res) => {
					if( res.data.code === 200 ) {
						this.List1 = res.data.data
					}else {
						this.$message.error(res.data.data)
					}
				})
		},
		init() {
			const {
				rid,
				system,
				company_id: companyId,
				type: companyType,
				superDepartmentName,
			} = this.UserInfo
			this.companyId = companyId
			this.staffId = rid
			let type = ''
			if (companyType === 1) {
				type = 'branchCompany'
				if (
					superDepartmentName === '客服部' ||
					superDepartmentName === '常规客服部'
				) {
					type = 'sonCompany'
				}
			} else if (companyType === 2) {
				type = 'sonCompany'
			} else if (system < 3) {
				type = 'departmentList'
			} else if (system === 3) {
				type = 'groupList'
			} else if (system === 4) {
				type = 'staffList'
			} else {
				return
			}
			this.getNextPower(rid, system, type)
		},
		getNextPower(rid, system, type) {
			const API = Baseurl + 'roleController/selectNextInfoByRid'
			const paramsData = { rid, system, companyId: this.companyId }
			ajaxPost(API,paramsData)
				.then((res) => {
					const {
						data: { code, data },
					} = res
					if( code === 200 ){
						this[type] = data.next
					}
				})
				.catch((e) => {

				})
		},
		selectChange(event, type) {
			const { rid, system, company_id: companyId } = event
			companyId && (this.companyId = companyId)
			this.getNextPower(rid, system, type)
			if (type === 'sonCompany') {
				this.selectForm.sonCompany = {}
				this.selectForm.departmentValue = {}
				this.selectForm.groupValue = {}
				this.selectForm.staffValue = {}
				this.sonCompany = []
				this.departmentList = []
				this.groupList = []
				this.staffList = []
			} else if (type === 'departmentList') {
				this.selectForm.departmentValue = {}
				this.selectForm.groupValue = {}
				this.selectForm.staffValue = {}
				this.departmentList = []
				this.groupList = []
				this.staffList = []
			} else if (type === 'groupList') {
				this.selectForm.groupValue = {}
				this.selectForm.staffValue = {}
				this.groupList = []
				this.staffList = []
			} else if (type === 'staffList') {
				this.selectForm.staffValue = {}
				this.staffList = []
			}
			this.staffId = rid
		},
		searchReset() {
			this.selectForm.departmentValue = ''
			this.selectForm.groupValue = ''
			this.selectForm.staffValue = ''
			this.selectForm.mark = ''
			this.selectForm.isTranslation = ''
			this.selectForm.value = ''
			this.selectForm.startTime = ''
			this.selectForm.endTime = ''
			this.selectForm.input = ''
			this.selectForm.timeType = ''
			this.selectForm.country = ''

			this.getAccountApplications()
			this.AccountNumber()
		},
		handleClick(item,event) {
			for(var i = 0; i < this.List.length; i++) {
				if(this.List[i].id === event) {
					var index = i
				}
			}
			this.arr = this.List[index]
			item.totalCost = this.arr.combinationPlanCost * item.applicationCount
			var s = 0;
            for(var i = this.buyerAccountApplicationList.length - 1; i >= 0; i--) {
                s += this.buyerAccountApplicationList[i].totalCost;
            }
            this.costTotal = s
		},
		handleClick1(event) {
			for(var i = 0; i < this.List.length; i++) {
				if(this.List[i].id === event) {
					var index = i
				}
			}
			this.arr1 = this.List[index]
			this.form1.totalCost = this.arr1.combinationPlanCost * this.form1.applicationCount
		},
		handeCanel(index) {
			this.buyerAccountApplicationList.splice(index,1)
			var s = 0;
            for(var i = this.buyerAccountApplicationList.length - 1; i >= 0; i--) {
                s += this.buyerAccountApplicationList[i].totalCost;
            }
            this.costTotal = s
		},
        handleChange(value) {
			this.buyerAccountApplicationList.map(item => item.totalCost = this.arr.combinationPlanCost * item.applicationCount)
			var s = 0;
            for(var i = this.buyerAccountApplicationList.length - 1; i >= 0; i--) {
                s += this.buyerAccountApplicationList[i].totalCost;
            }
            this.costTotal = s
        },
        handleChange1(value) {
			this.form1.totalCost = this.arr1.combinationPlanCost * this.form1.applicationCount
        },
        edit() {
			this.buyerAccountApplicationList = [
				{ 
					applicationCount: '1',
					totalCost: 0
				}
			],
			this.costTotal = 0;
            this.EditReimbursement = true;
        },
        handleSizeChange(val) {
			this.size = val
			this.getAccountApplications()
		},
		handleCurrentChange(val) {
			this.page = val
			this.getAccountApplications()
		},
        EditbankCard() {
			let arry = this.buyerAccountApplicationList
			let arryNew = []
			arry.map((item, index) => {
				arryNew.push(Object.assign({}, item, { applicant: this.staffId, companyId: this.companyId  }))
			})
			for(var i = 0; i < arryNew.length; i++) {
				if(arryNew[i].buyerAccountCombinationId == undefined) {
					this.$message('请选择买家账号组合方案')
				}else if(arryNew[i].countryCode == undefined) {
					this.$message('请选择申请国家')
				}else {
					const API =  Baseurl + 'buyerAccountApplicationController/batchInsertBuyerAccountApplication'
					const paramsData = {      
						buyerAccountApplicationList: arryNew                                      
					}
					ajaxPost(API,paramsData)
						.then((res) => {
							if( res.data.code === 200 ) {
								this.EditReimbursement = false
								this.buyerAccountApplicationList = [{}]
								this.getAccountApplications()
							}else {
								this.$message.error(res.data.data)
							}
						})
				}
			}
        },
        addPlan(){
            var params = {
				applicationCount: '1',
				totalCost: 0
            }
            this.buyerAccountApplicationList.push(params)
        },
	},
}
</script>

<style lang="scss" scoped>
.BuyerAccountApplicationRecord {
	width: 98%;
	// background: #F7F7F7;
	padding-bottom: 72px;
	.summary_bag {
		width: 98%;
		margin: auto;
		.summary_complete_bag {
			overflow: hidden;
            .span-box{
                display: flex;
                align-items: center;
                justify-content: flex-end;
                margin-top: 15px;
                .el-icon-question{
                    font-size: 14px;
                }
            }
		}
		.summary_pagenum {
			width: 99.6%;
			margin-bottom: 10px;
			overflow: hidden;
			background: #f5f5f5;
            display: flex;
            justify-content: flex-end;
            padding: 5px;
		}
		.summary_content {
			width: 100%;
			border: 1px solid #eee;
			overflow: hidden;
            .summary_list {

            }
		}
		.summary_pagenum_block {
			width: 1790px;
			padding: 20px;
			position: fixed;
			right: 0;
			bottom: 0;
			background: #fff;
			z-index: 999;
			.el-pagination {
				display: flex;
				justify-content: center;
			}
		}
	}
    .form{
        padding: 10px 0;
        border-bottom: 1px solid #DCDFE6;
        .el-input{
            width: 200px;
        }
        .el-input-number{
            width: 200px;
        }
        .el-select{
            width: 200px;
        }
    }
}
</style>
